<template>
  <div class="test-div">
    <main>
      <article>
        <section class="section">
          <h1 class="title">Iventerとは</h1>
          <p>Iventerはイベントの売買計算を助けるためのツールです！</p>
        </section>
        <section class="section">
          <h2 class="subtitle has-text-weight-semibold">イベントを追加</h2>
          <p>参加する予定のイベントを追加しましょう。</p>
          <hr>
        </section>
        <section class="section">
          <h2 class="subtitle has-text-weight-semibold">商品を追加</h2>
          <p>イベントで売る、買う商品を追加しましょう。</p>
          <hr>
        </section>
        <section class="section">
          <h2 class="subtitle has-text-weight-semibold">合計金額の計算</h2>
          <p>イベントで売る、買う商品の数を設定しましょう。</p>
          <p>清算ボタンを押すことで合計金額をリセットすることができます。</p>
          <hr>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
export default {
  name: "How",
  data: function() {
    return {};
  }
};
</script>

<style>
.test-div {
  flex: 1;
}

.full-width {
  min-width: 100%;
}
</style>
